import { Button, Drawer, Typography } from "antd";
import { PlusOutlined } from "@ant-design/icons";

import { AdminMenuLayout } from "../../../shared/components";
import { WrapperCard, WrapperTabNav } from "./styled";
import React from "react";
import { useProducts } from "../../products";
import { useNavigate } from "react-router-dom";
import { TableProduct3x2 } from "./TableProduct3x2";
import { Product3x2Form } from "./form/Product3x2Form";
const { Text } = Typography;

export const Product3x2 = () => {
  const {
    querySelectorTransform,
  } = useProducts();
  const [openModalCreateProductToGift, setOpenModalCreateProductToGift] = React.useState<boolean>(false)
  const navigate = useNavigate()
  return (
    <AdminMenuLayout pageDescription="Products" title="Products">
      <WrapperCard>
        <div style={{width: '100%'}}>

        <Text style={{color: 'gray', cursor: 'pointer'}} onClick={()=>navigate('/rules-3-x-2-products')}>Ir atras</Text>
        </div>
        <WrapperTabNav
          items={[
            {
              label: `PRODUCTOS AÑADIDOS SIN COSTO`,
              key: "3",
              children: (
                <>
                  <div style={{ display: "flex", justifyContent: "end" }}>
                    {" "}
                    <Button
                      type="primary"
                      shape="round"
                      icon={<PlusOutlined />}
                      size="large"
                      onClick={()=>setOpenModalCreateProductToGift(true)}
                    >
                      Agregar producto con menor descuento
                    </Button>
                  </div>
                  <TableProduct3x2 fetchQuery={querySelectorTransform} />
                </>
              ),
            },
          ]}
        />
         <Drawer
          title={`Agregar producto con menor descuento`}
          open={openModalCreateProductToGift}
          width={"320px"}
          destroyOnClose
          onClose={() => setOpenModalCreateProductToGift(false)}
        >
          <Product3x2Form setOpenModalCreate={setOpenModalCreateProductToGift} />
        </Drawer>
      </WrapperCard>
    </AdminMenuLayout>
  );
};
